import { useCallback } from "react";
import { Button, Row, TextLabel } from "../lib";
import { BookingItem, BookingItemProps } from "./booking-item";

type Props = BookingItemProps & {
  onShow?: (id: number) => void;
};

export function BookingItemAccepted({ onShow, ...rest }: Props) {
  // Vars
  const { booking } = rest;

  // Handlers
  const handleShow = useCallback(() => {
    onShow?.(booking.id);
  }, [booking.id, onShow]);

  // Render
  const actionsEl = (
    <Row.LR>
      <TextLabel>{booking.status_text.toUpperCase()}</TextLabel>
      <Button compact onPress={handleShow}>
        Show details
      </Button>
    </Row.LR>
  );

  return <BookingItem {...rest} onShow={onShow} actions={actionsEl} />;
}
